import React from 'react';

const Message = ({ type, text }) => {
  return (
    <div className={`mt-4 p-3 rounded font-suwannaphum ${type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
      {text}
    </div>
  );
}

export default Message;
